import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { FullTask, TaskComment, TaskFileHistory } from '../types';

export const taskLoaders = getLoaders({
  findTask: {
    load: async ({
      projectId,
      taskId,
    }: {
      projectId: string;
      taskId: string;
    }): Promise<FullTask> => {
      return executeApiCall({
        path: `/projects/${projectId}/${taskId}`,

        method: 'get',
      });
    },
  },

  taskCommentHistory: {
    load: async ({ id }: { id: string }): Promise<TaskComment[]> => {
      return executeApiCall({
        path: `/projects/tasks/comment/history/${id}`,

        method: 'get',
      });
    },
  },

  taskFileHistory: {
    load: async (payload: { fileId: string }): Promise<TaskFileHistory[]> => {
      return executeApiCall({
        path: `/projects/files/history`,

        method: 'get',

        payload,
      });
    },
  },
});
